import { departmentQuery } from "@common/api/departments"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { DepartmentDetailsForm } from "@/routes/_layout/settings/_panel/workspace/departments/-components/form/department-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/departments/_list/$departmentId",
)({
  loader: ({ context: { queryClient }, params: { departmentId } }) =>
    queryClient.ensureQueryData(departmentQuery(departmentId)),
  staticData: { detailSidebar: true },
  component: DepartmentPanel,
})

function DepartmentPanel(): React.ReactElement {
  const { departmentId } = Route.useParams()
  const { data: department } = useSuspenseQuery(departmentQuery(departmentId))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({ to: "/settings/workspace/departments", search: true })

  return (
    <DepartmentDetailsForm
      key={`${department.id}-${department.deleted_at}`}
      department={department}
      onClose={close}
      onRestore={() => showToast("Restored", "Record restored.", "success")}
      onSave={(saved) =>
        showToast("Saved", `${saved.name} updated.`, "success")
      }
    >
      <Outlet />
    </DepartmentDetailsForm>
  )
}
